import React, { Component } from "react";
import PropTypes from "prop-types";
import SendMessageConfirmModal from "./send_message_confirm_modal";

class FooterSendMessageButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalShow: false
    };
  }

  handleModalShow = () => {
    this.setState(prevState => (
      { isModalShow: !prevState.isModalShow }
    ));
  };

  render () {
    const { isModalShow } = this.state;
    const { name, contactable } = this.props;

    return contactable === true && (
      <div id='button_footer' className='container-fluid d-lg-none'>
        <div className='row'>
          <div className='col-12'>
            <button type='button' className='btn btn-primary btn-m' data-ga-label='btn-message-foot' onClick={this.handleModalShow}>
              メッセージを送る
            </button>
          </div>
        </div>

        <SendMessageConfirmModal
          name={name}
          isModalShow={isModalShow}
          handleModalShow={this.handleModalShow}
        />
      </div>
    );
  }
}

FooterSendMessageButton.propTypes = {
  name: PropTypes.string.isRequired,
  contactable: PropTypes.bool.isRequired
};

export default FooterSendMessageButton;
